export const useClientRequest= defineStore('repo.client.request', () => {
    const path = ref(null);
    const headers = ref({});
    const method = ref('GET');
    const options = ref(null);
    const body = ref(null);

    const { data, error, status, execute, refresh } = useFetch(path, {
        baseURL: '/api',
        method: method,
        headers: headers,
        body: body,
        immediate: false,
        watch: false,
        ...ref(options.value) // ????? !!!!!
    });

    const request = {
        execute: async (url: string, opts?: any) => {
            headers.value = {
                Accept: "application/json",
                'Content-Type': 'application/json; charset=utf-8',
                "Cache-Control": "no-cache",
                'X-Requested-With': 'pipeline-client-2',
                ...opts?.headers
            };

            options.value = opts ? (({ headers, method, body, ...o }) => o)(opts) : null;

            method.value = opts.method ?? method.value;
            path.value = url;
            body.value = opts.body ?? null;

            console.log('Execute request.');

            await execute();

            return {
                data: data.value,
                status: status.value,
                error: error.value
            }
        },
        refresh: refresh
    }
    
    return {
        request
    };
});